/** @domain transaction -- Release, settlement, and bulk execution transaction fields. */
import { z } from 'zod';
import { createDomainField } from './types';
import { commaFormatter } from './formatters';

const define = createDomainField('transaction');

export const expectedReleaseDate = define({
  label: 'Expected Release Date',
  schema: z.string(),
  adapterHint: 'date',
  displayFormat: 'date',
});

export const releaseName = define({
  label: 'Release Name',
  placeholder: 'Enter release name',
  schema: z
    .string()
    .max(200, 'Must be at most 200 characters')
    .regex(/^\s*\S[\s\S]*$/, 'Must not be blank'),
  adapterHint: 'text',
  displayFormat: 'text',
});

export const bulkExecutionName = define({
  label: 'Bulk Execution Name',
  placeholder: 'Enter name',
  schema: z.string().max(200, 'Must be at most 200 characters'),
  adapterHint: 'text',
  displayFormat: 'text',
});

export const ignoreBrokerage = define({
  label: 'Ignore Brokerage',
  schema: z.boolean(),
  adapterHint: 'checkbox',
  displayFormat: 'boolean',
});
